import { getAssetUrl } from "./url";

/**
 * Fetches a remote asset.
 */
export async function fetchAsset(
  path: string,
  signal?: AbortSignal,
): Promise<string> {
  return new Promise((resolve, reject) => {
    const url = getAssetUrl(path);

    fetch(url, { signal })
      .then(async (r) => {
        const text = await r.text();
        if (!r.ok) reject(text);
        resolve(text);
      })
      .catch((e) => reject(e));
  });
}
